import { AppShell as MantineAppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Suspense } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { Navbar } from '../Navbar';
import { useCustomRoutes } from '../../hooks/useCustomRoutes/useCustomRoutes';
import useAuth from '../../hooks/useAuth';
import { LoaderAbsolute } from '../../libs/ui-atoms';
import { GlobalModalProvider } from '../../libs/ui-atoms/providers/GlobalModalProvider';
import {
  ServiceWorkerNotification,
  RegisterRequestAccessContainer,
  ValidUseTermContainer,
} from '../../libs/ui-molecules';
import { getMe } from '../../services/LocalStorageService';

const AppShell = () => {
  const { loggedIn, hasConsent, isRoleProducer, isImpersonating } = useAuth();
  const [opened, handlers] = useDisclosure(false);
  const location = useLocation();
  const navigate = useNavigate();
  const routing = useCustomRoutes();
  const isDocumentationRoute = location.pathname?.includes('/docs/api');

  if (
    getMe() &&
    !hasConsent('MAPAQ_COMMS') &&
    !isImpersonating &&
    location.pathname !== '/profile'
  ) {
    navigate('/profile');
  }

  return (
    <MantineAppShell
      layout="alt"
      navbarOffsetBreakpoint="sm"
      asideOffsetBreakpoint="sm"
      navbar={
        loggedIn ? (
          <Navbar
            openedSide={loggedIn && !isDocumentationRoute}
            opened={opened}
            handlers={handlers.close}
          />
        ) : (
          <div />
        )
      }
      footer={loggedIn ? <Footer /> : <div />}
      header={<Header />}
    >
      <Suspense fallback={<LoaderAbsolute />}>
        <ServiceWorkerNotification />
        {loggedIn && !isImpersonating && <ValidUseTermContainer allowConsent isFullScreen />}
        {loggedIn && isRoleProducer && !isImpersonating && <RegisterRequestAccessContainer />}
        <GlobalModalProvider>{routing}</GlobalModalProvider>
      </Suspense>
    </MantineAppShell>
  );
};

export default AppShell;
